import clsx from 'clsx'
import {API_IMG_AVATR} from 'app/modules/core'
import {toAbsoluteUrl} from '_metronic/helpers'
type Props = {
  fielName?: string | null
}

export const ImageAvatar = (props: Props) => {
  return (
    <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
      <div>
        {props.fielName ? (
          <div className='symbol-label'>
            <img src={`${API_IMG_AVATR}/${props.fielName}`} alt='avatar' className='w-100' />
          </div>
        ) : (
          <div className={clsx('symbol-label fs-5', `bg-light-primary`, `text-center`)}>
            <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='avatar' className='w-100'/>
          </div>
        )}
      </div>
    </div>
  )
}
